// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__6al3Z","panelRow":"Panel_panelRow__yWGiu","fluid":"Panel_fluid__5+1me","panelHighlighted":"Panel_panelHighlighted__Jw0Vz","blink":"Panel_blink__1RwrZ"};